import * as React from "react";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import IConditionsUI from "../../../models/IConditionsUI";
import * as _ from "lodash";
import {AppConstants} from "../../../utils/AppConstants";
import ModelFactory from "../../../models/ModelFactory";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";
/**
 * Created by prachi on 16/03/18.
 */
export interface PatientConditionsViewProps {
    conditions: IConditionsUI[],
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}

class PatientConditionsView extends React.Component<PatientConditionsViewProps> {
    render() {
        let ConditionViewHeaderInfos: ICustomHeaderInfo[] = [
            {label: "condition", display: "CONDITION"},
            {label: "from", display: "FROM"},
            {label: "to", display: "TO"},
            {label: "specifics", display: "SPECIFICS"}
        ];
        let conditionsExist = this.props.conditions.length > 0;
        // Assuming relationship will be self for patient conditions only
        let isRelationCondition = conditionsExist && this.props.conditions[0].items && this.props.conditions[0].items[0].relationship
            && this.props.conditions[0].items[0].relationship !== "SELF";
        if (isRelationCondition) {
            ConditionViewHeaderInfos.splice(1, 0, {label: "relationship", display: "RELATIVE"})
        }
        return <div className="patient-condition-view">
            {
                !_.isEmpty(this.props.questionnaire) &&
                <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
            }
            {/*<CustomHeader headerInfos={ConditionViewHeaderInfos} rootCls={"patient-condition"}/>*/}
            {conditionsExist && _.map(this.props.conditions, (condition, index: number) => {
                let showCondition = condition.items.length > 0 && ModelFactory.isValidCondition(condition.items[0]);
                if (showCondition) {
                    return <div key={index} className="history-view-row">
                        <div key={index} className="condition-item-view" style={{width: "120%"}}>
                            <div className="patient-condition-condition condition-view-col">
                                <div className="condition-view-col">{condition.name}</div>
                            </div>
                            {_.map(condition.items, (item, index: number) => {
                                if (ModelFactory.isValidCondition(item)) {
                                    return <div className={"relationship-card"} key={`relationship-${item.internalValue}-${index}`}>
                                        <div>{AppConstants.PatientRelationshipConstant[item.relationship].displayValue}</div>
                                        {
                                            !_.isNull(item.onSetAge) &&
                                            <div className={"onset-age"}>{`Onset age: ${item.onSetAge} yrs`}</div>
                                        }
                                        <div>{!_.isEmpty(item.tillDate) ? `- ${item.tillDate}` : null}</div>
                                    </div>
                                }
                            })}
                        </div>
                    </div>
                }
            })}
            {!conditionsExist && <div className={"no-record-found-label"}>No past conditions found!</div>}
        </div>
    }
}

export default PatientConditionsView